import { Box, Stack, Typography } from "@mui/material";
import { SyncCard } from "features/dataConnectors";
import Shopify_logo from "Assets/Images/ThirdParty/shopify_logo_black.png";
import {
  ApiAPITokenType,
  ApiProject,
  ApiService,
  ApiSyncType,
} from "@incendium/api";
import Shopify from "features/dataConnectors/components/Shopify";
import ShopifyConnectButton from "features/dataConnectors/components/ShopifyConnectButton";
import ProjectCodeSnippet from "features/project/components/ProjectCodeSnippet";
import APITokenCard from "features/dataConnectors/components/APITokenCard";
import AccordianGlassCard from "Components/UI/AccordianGlassCard";
import { OAUTH_REDIRECT_URL } from "features/auth/constants";
import { useState } from "react";

interface IOnboardinPixelShopifyProps {
  project: ApiProject;
}

function OnboardinPixelShopify({ project }: IOnboardinPixelShopifyProps) {
  const [appOpen, setAppOpen] = useState(true);
  const [manualOpen, setManualOpen] = useState(false);
  return (
    <Stack spacing={4}>
      <AccordianGlassCard
        onOpenChange={(b) => setAppOpen(b)}
        defaultClosed={!appOpen}
        title={
          <>
            <Typography variant="subtitle1">
              Use the Incendium Shopify App (recomended)
            </Typography>
            <Typography variant="body1">
              The best and easiest way to install the Incendium pixel is to
              connect via our shopify app
            </Typography>
          </>
        }
      >
        <SyncCard
          logo={Shopify_logo}
          type={ApiSyncType.SHOPIFY_API}
          title="Shopify App"
          description="Connect with your Shopify store for more accurate tracking and ecommerce insights."
          service={ApiService.SHOPIFY}
          configComponent={Shopify}
          state={OAUTH_REDIRECT_URL}
          imageSx={{ maxHeight: 32 }}
          ConnectButton={ShopifyConnectButton}
          linkOnConnect
          hideConfigure
        />
      </AccordianGlassCard>

      <AccordianGlassCard
        onOpenChange={(b) => setManualOpen(b)}
        defaultClosed={!manualOpen}
        title={
          <>
            <Typography variant="subtitle1">
              Manually Install Incendium
            </Typography>
            <Typography variant="body1">
              Add the main incendium pixel to either your theme or gtag
            </Typography>
          </>
        }
      >
        <ProjectCodeSnippet project={project} />

        <Typography variant="body1" my={2}>
          Then Generate the webhook, once generated a drawer shall open with
          instuctions how to add to your Shopify Store
        </Typography>
        <APITokenCard
          title="Shopify Webhooks"
          type={ApiAPITokenType.API_TOKEN_TYPE_SHOPIFY}
          clientId={project.clientId as number}
          projectId={project.id as number}
          projectKey={project.key || ""}
          logo={Shopify_logo}
          imageSx={{ maxHeight: 35 }}
          info={
            <Box>
              <Typography variant="body2" color={"text.secondary"}>
                Selecting this will generate an auth key. Use this key to add
                Incendium Webhooks to your store.
              </Typography>
            </Box>
          }
        />
      </AccordianGlassCard>
    </Stack>
  );
}

export default OnboardinPixelShopify;
